import React, {createContext, useContext, useState, useMemo, useEffect} from 'react';
import { validateAndRefreshToken } from '../commons/tokenUtils';

// Context 생성
export const IsLoginContext = createContext();

export function IsLoginProvider({children}) {
    // 초기값은 false로 설정 (토큰 검증 후 업데이트)
    const [isLogin, setIsLogin] = useState(false);
    const [user, setUser] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false); // 초기화 완료 여부

    // 앱 초기화 시 토큰 유효성 검증
    useEffect(() => {
        const initializeAuth = async () => {
            console.log('토큰 유효성 검증 시작...');

            try {
                const accessToken = localStorage.getItem('access_token');
                const refreshToken = localStorage.getItem('refresh_token');

                // 리프레시 토큰이 없으면 로그인되지 않은 상태
                if (!refreshToken) {
                    console.log('리프레시 토큰 없음 - 로그인 필요');
                    setIsLogin(false);
                    setUser(null);
                    setIsInitialized(true);
                    return;
                }

                // 토큰 유효성 검증 및 자동 갱신 시도
                const isValid = await validateAndRefreshToken();

                if (isValid) {
                    console.log('토큰 유효 - 로그인 상태 유지');
                    setIsLogin(true);

                    // 사용자 정보 복원
                    const memberId = localStorage.getItem('memberId');
                    const memberNm = localStorage.getItem('memberNm');
                    const role = localStorage.getItem('role');

                    if (memberId) {
                        setUser({
                            memberId,
                            memberNm: memberNm || '',
                            role: role || ''
                        });
                        console.log('사용자 정보 복원 완료:', { memberId, memberNm, role });
                    }
                } else {
                    console.log('토큰 무효 - 로그인 상태 해제');
                    setIsLogin(false);
                    setUser(null);
                }
            } catch (error) {
                console.error('토큰 검증 중 오류:', error);
                setIsLogin(false);
                setUser(null);
                // 오류 발생 시에만 localStorage 정리
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
            } finally {
                setIsInitialized(true);
            }
        };

        initializeAuth();
    }, []);

    // useMemo를 사용하여 props 변경 시에만 컨텍스트 값이 재계산되도록 함
    const value = useMemo(() => ({
        isLogin,
        setIsLogin,
        user,
        setUser,
        isInitialized // 초기화 완료 여부도 제공
    }), [isLogin, user, isInitialized]);

    return (
        <IsLoginContext.Provider value={value}>
            {children}
        </IsLoginContext.Provider>
    );
}

export function useIsLoginState() {
    const context = useContext(IsLoginContext);
    if (!context) {
        throw new Error('useIsLoginState must be used within an IsLoginProvider');
    }
    return context;
}